import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Paper,
    CircularProgress,
    useMediaQuery,
} from "@mui/material";

const OpportunitiesTable = () => {
    const [opportunities, setOpportunities] = useState([]);
    const [loading, setLoading] = useState(true);

    const isMobile = useMediaQuery("(max-width:1000px)");

    const formatPhoneNumber = (phone) => {
        const match = phone.match(/(\+1)(\d{3})(\d{3})(\d{4})/);
        if (match) {
            return `${match[1]}-${match[2]}-${match[3]}-${match[4]}`;
        }
        return phone;
    };

    useEffect(() => {
        const fetchOpportunities = async () => {
            try {
                const response = await fetch("/filtered_opportunities.json");
                const data = await response.json();

                const formattedData = data.map((opportunity) => ({
                    ...opportunity,
                    phone: formatPhoneNumber(opportunity.phone),
                }));

                setOpportunities(formattedData);
            } catch (error) {
                console.error("Error loading opportunities:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchOpportunities();
    }, []);

    if (loading) {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                    backgroundColor: "#1E1E1E",
                }}
            >
                <CircularProgress sx={{ color: "#98FF98" }} />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                padding: "16px",
                backgroundColor: "#1E1E1E",
                borderRadius: "12px",
                color: "#FFF",
            }}
        >
            <Typography
                variant="body1"
                sx={{ color: "gray", marginBottom: "24px" }}
            >
                Christmas 2024
            </Typography>
            {isMobile ? (
                <Box>
                    {opportunities.map((opportunity, index) => (
                        <Paper
                            key={index}
                            sx={{
                                backgroundColor: "#2E2E2E",
                                marginBottom: "16px",
                                padding: "16px",
                                borderRadius: "8px",
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    color: "#FFF",

                                    marginBottom: "8px",
                                }}
                            >
                                {opportunity["Opportunity Name"]}
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#98FF98",
                                    fontSize: "16px",

                                    marginBottom: "8px",
                                }}
                            >
                                {opportunity.phone}
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#888",

                                }}
                            >
                                {opportunity.email}
                            </Typography>
                        </Paper>
                    ))}
                </Box>
            ) : (
                <TableContainer
                    component={Paper}
                    sx={{
                        backgroundColor: "#1E1E1E",
                        marginTop: "16px",
                        maxWidth: "960px",
                        margin: "0 auto",
                    }}
                >
                    <Table>
                        <TableBody>
                            {opportunities.map((opportunity, index) => (
                                <TableRow key={index} hover>
                                    <TableCell
                                        sx={{
                                            color: "#FFF",
                                            fontSize: "16px",

                                        }}
                                    >
                                        {opportunity["Opportunity Name"]}
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            color: "#98FF98",
                                            fontSize: "16px",

                                        }}
                                    >
                                        {opportunity.phone}
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            color: "#888",

                                        }}
                                    >
                                        {opportunity.email}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Box>
    );
};

export default OpportunitiesTable;
